import {
  Activity,
  BarChart2,
  BarChart3,
  BookOpen,
  CalendarClock,
  Car,
  FileText,
  Gauge,
  Landmark,
  LayoutDashboard,
  Mail,
  Map,
  Megaphone,
  Radio,
  Receipt,
  Scale,
  Settings,
  TrendingUp,
  Users,
} from 'lucide-react';

export const PARTNER_NAV_LINKS = [
  { to: '/', label: 'Home', end: true, icon: LayoutDashboard, group: 'overview', description: 'Tageslage, Flottenstatus, Einnahmen und aktuelle Fahrten auf einen Blick.' },
  { to: '/live-map', label: 'Live-Karte', icon: Map, group: 'overview', description: 'Eigene Fahrer und Fahrzeuge live im Einsatzgebiet verfolgen.' },

  { to: '/dispatch', label: 'Dispatch', icon: Radio, group: 'ops', description: 'Laufende Vermittlung und offene Einsatzlage der eigenen Flotte koordinieren.' },
  { to: '/reservations', label: 'Reservierungen', attention: 'reservations', icon: CalendarClock, group: 'ops', description: 'Geplante Fahrten prüfen, zuweisen, freigeben oder begründet ablehnen.' },
  { to: '/drivers', label: 'Fahrer', icon: Users, group: 'ops', description: 'Eigene Fahrer finden, einladen, freigeben und ihrem Einsatzstatus folgen.' },
  { to: '/vehicles', label: 'Fahrzeuge', icon: Car, group: 'ops', description: 'Eigene Fahrzeugflotte, Fahrerzuordnung, Klassen und Konzessionen verwalten.' },
  { to: '/order-log', label: 'Auftragsbuch', icon: BookOpen, group: 'ops', description: 'Gesetzliches Auftragsbuch der eigenen Flotte filtern und exportieren.' },
  { to: '/documents', label: 'Dokumente', icon: FileText, group: 'ops', description: 'Pflichtunterlagen, Revisionen, Ablaufdaten und Banknachweise im Blick behalten.' },

  { to: '/performance', label: 'Leistung', icon: Activity, group: 'perf', description: 'Flottenqualität, Annahmequote und betriebliche Leistung nach Zeitraum auswerten.' },
  { to: '/driver-performance', label: 'Fahrer-Leistung', icon: Gauge, group: 'perf', description: 'Leistung und Qualitätskennzahlen der eigenen Fahrer vergleichen.' },
  { to: '/reports', label: 'Berichte', icon: BarChart3, group: 'perf', description: 'Fahrten- und Betriebsberichte für die eigene Flotte erstellen.' },
  { to: '/earnings', label: 'Einnahmen', icon: TrendingUp, group: 'perf', description: 'Nachträglich unveränderbare Buchungen nach Fahrer informativ nachvollziehen; keine Abrechnung.' },

  { to: '/balance', label: 'Banking', icon: Landmark, group: 'finance', description: 'Offenen Kontostand bei VOOGO und freigegebene Bankverbindung einsehen.' },
  { to: '/settlements', label: 'Abrechnung', icon: Receipt, group: 'finance', description: 'Unveränderliche Umsatzübersichten, VOOGO-Gebührenrechnungen, CSV und Auszahlungsstatus abrufen.' },
  { to: '/promotions', label: 'Aktionen', icon: Megaphone, group: 'finance', description: 'Fahrerboni und zeitlich begrenzte Flottenaktionen steuern.' },

  { to: '/inbox', label: 'Support & Postfach', icon: Mail, group: 'comm', description: 'Support direkt anschreiben und partnerbezogene Gespräche oder Hinweise lesen.' },
  { to: '/legal', label: 'Rechtliches', icon: Scale, group: 'comm', description: 'Aktuelle Partnerbedingungen und veröffentlichte Rechtstexte nachlesen.' },

  { to: '/driver-stats', label: 'Fahrer-Umsatz', icon: BarChart2, group: 'account', description: 'Umsatz- und Fahrtenwerte der eigenen Fahrer nach Zeitraum vergleichen.' },
  { to: '/settings', label: 'Einstellungen', icon: Settings, group: 'account', description: 'Firmendaten, Kontakt, Bankverbindung und Kontosicherheit pflegen.' },
];

export const PARTNER_NAV_GROUPS = [
  { id: 'overview', label: 'Überblick', description: 'Aktuelle Flottenlage' },
  { id: 'ops', label: 'Betrieb', description: 'Fahrer, Fahrzeuge und Einsätze' },
  { id: 'perf', label: 'Leistung', description: 'Qualität und Entwicklung' },
  { id: 'finance', label: 'Finanzen', description: 'Einnahmen und Abrechnung' },
  { id: 'comm', label: 'Kommunikation', description: 'Nachrichten und Recht' },
  { id: 'account', label: 'Konto', description: 'Unternehmen und Sicherheit' },
];

export const PARTNER_ENTRY_POINTS = [
  { to: '/login', label: 'Anmeldung' },
  { to: '/register', label: 'Registrierung' },
  { to: '/onboarding', label: 'Freischaltung' },
];

export const filterPartnerNavigation = (links, query) => {
  const normalized = String(query || '').trim().toLocaleLowerCase('de');
  return normalized
    ? links.filter((item) => `${item.label} ${item.description || ''}`.toLocaleLowerCase('de').includes(normalized))
    : links;
};

export const getPartnerNavigationContext = (pathname) => {
  const normalizedPath = String(pathname || '/');
  if (normalizedPath.startsWith('/drivers/')) {
    const drivers = PARTNER_NAV_LINKS.find((entry) => entry.to === '/drivers');
    return {
      item: { ...drivers, label: 'Fahrerprofil', description: 'Leistung, Voraussetzungen, Einnahmen und Aktivität des ausgewählten Fahrers.' },
      group: PARTNER_NAV_GROUPS.find((entry) => entry.id === 'ops') || null,
    };
  }
  const item = PARTNER_NAV_LINKS.find((entry) => (
    entry.end ? normalizedPath === entry.to : (entry.to !== '/' && normalizedPath.startsWith(entry.to))
  ));
  if (item) {
    return {
      item,
      group: PARTNER_NAV_GROUPS.find((entry) => entry.id === item.group) || null,
    };
  }
  return { item: null, group: null };
};
